import { ENDPOINTS } from '../../../shared/constants/url.constants';
import { GlobalErrorHandlerService } from '../../../shared/services/global-error-handler.service';
import { HttpRequestService } from '../../../shared/services/http-request.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { formatUrl } from '../../../shared/utils/format-url-util';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthorizationService {
    constructor(
        private http: HttpRequestService,
        private errorHandler: GlobalErrorHandlerService,
        private notificationService: NotificationService
    ) { }

    getProviderAuthUsageByProvider(programCode: string, participantId: number, clientAuthNumber: string, rfrwRequest = false): Observable<any> {
        const url = formatUrl(ENDPOINTS.AUTH_SUMMARY.POST_CONSUMER_AUTH_USAGE_PROVIDER, { program_code: programCode });
        const body = {
            participantId,
            clientAuthNumber
        };
        return this.http.post(url, body, rfrwRequest).pipe(
            catchError(error => {
                return throwError(() => this.errorHandler.handleError(error));
            })
        );
    }

    getConsumerAuthUsage(programCode: string, participantId: number, clientAuthNumber: string, rfrwRequest = false): Observable<any> {
        const url = formatUrl(ENDPOINTS.AUTH_SUMMARY.POST_CONSUMER_AUTH_USAGE, { program_code: programCode });
        const body = {
            participantId,
            clientAuthNumber: clientAuthNumber
        };
        return this.http.post(url, body, rfrwRequest).pipe(
            catchError(error => {
                return throwError(() => this.errorHandler.handleError(error));
            })
        );
    }

    getConsumerAuthList(programCode: string, participantId: number, rfrwRequest = false): Observable<any> {
        const url = formatUrl(ENDPOINTS.AUTH_SUMMARY.GET_CONSUMER_AUTHS, { program_code: programCode, participant_id: participantId });
        return this.http.get(url, rfrwRequest).pipe(
            catchError(error => {
                return throwError(() => this.errorHandler.handleError(error));
            })
        );
    }

    getOverallBudget(programCode: string, payload: any, rfrwRequest = false): Observable<any> {
        const url = formatUrl(ENDPOINTS.AUTH_SUMMARY.POST_OVERALL_BUDGET, { program_code: programCode });
        return this.http.post(url, payload, rfrwRequest).pipe(
            catchError(error => {
                return throwError(() => this.errorHandler.handleError(error));
            })
        );
    }

    getCategoryChartData(programCode: string, payload: any, rfrwRequest = false): Observable<any> {
        const url = formatUrl(ENDPOINTS.AUTH_SUMMARY.POST_CONSUMER_CATEGORY_OVERALL_BUDGET, { program_code: programCode });
        return this.http.post(url, payload, rfrwRequest).pipe(
            catchError(error => {
                return throwError(() => this.errorHandler.handleError(error));
            })
        );
    }

    getConsumerMonthlyChartData(programCode: string, payload: any, rfrwRequest = false): Observable<any> {
        const url = formatUrl(ENDPOINTS.AUTH_SUMMARY.POST_CONSUMER_MONTHLY_SPENDING, { program_code: programCode });
        return this.http.post(url, payload, rfrwRequest).pipe(
            catchError(error => {
                return throwError(() => this.errorHandler.handleError(error));
            })
        );
    }
}